import {
  FREE_FOR_MEMBERS_LABEL,
  MEMBERS_PAY_LABEL_PREFIX,
} from '../constants/orderPricing';
import { formatUsd } from './formatUsd';

/**
 * Compact right-aligned member-savings label for public catalog tiles.
 *
 * Returns null when there is no member savings (list-only or free items).
 * A zero member price becomes {@link FREE_FOR_MEMBERS_LABEL} instead of
 * “Members pay $0.00” (animated e-cards).
 */
export function formatMembersPayLabel(
  listUsd: number,
  memberUsd: number,
): string | null {
  if (!(memberUsd < listUsd)) {
    return null;
  }

  if (memberUsd <= 0) {
    return FREE_FOR_MEMBERS_LABEL;
  }

  return `${MEMBERS_PAY_LABEL_PREFIX} ${formatUsd(memberUsd)}`;
}
